;(function ($, YI) {YI.commerceMap = function () {

    var info = [
        {id: 250, liter: '8'},
        {id: 22, liter: '9/1'},
        {id: 34, liter: '9/2'}
    ];

    var $headBlock = $('#headBlock');
    if ($headBlock.length) {
        //var $offset = $('#commerce_offset');
        var $commerceBlock = $('.commerce-map');
        resize();
        $(window).resize(function () {
            resize();
        });
        function resize() {
            $commerceBlock.css('height', $(window).height()-$headBlock.height());
            //$offset.css('min-height', $headBlock.height());
        }
    }

    // всплывающее инфо
    var $liter_name = $('#commerce_liter'),
        $fasad = $('.commerce-map__fasad'),
        $path_info = $('.commerce-map__fasad__path-info');
    $('.commerce-map__fasad__path').mousemove(function (e) {
        var $this = $(this),
            relativeX = e.pageX,
            relativeY = e.pageY - $fasad.offset().top;
        $liter_name.text(info[$this.index()].liter);
        $path_info.css({
            left: relativeX,
            top: relativeY
        });
    }).mouseleave(function () {
        $path_info.css({
            left: '',
            top: ''
        });
    }).click(function () {
        location.href = 'commerce-storey.php?id=' + info[$(this).index()].id;
    });

}})(jQuery, window.yesidea || (window.yesidea = {}));